import clsx from "clsx";
import { motion } from "motion/react";
import type { ChildrenProps } from "../types";
import { useAppShellStore } from "./store";

export interface AppShellProps extends ChildrenProps {
	sidebarNavigation: () => React.ReactNode;
	topbarNavigation: () => React.ReactNode;
}

export function AppShellWrapper({ children, sidebarNavigation, topbarNavigation }: AppShellProps) {
	/** Context */
	const store = useAppShellStore();

	const isTopbar = store.layout === "topbar";
	const isSidebar = store.layout === "sidebar";

	/** Render */
	return (
		<div
			key="app-shell"
			id="app-shell"
			className={clsx(
				"flex justify-center items-center w-screen h-screen",
				"p-1.5",
				isTopbar && "bg-white dark:bg-black gap-2",
				isSidebar && "bg-white dark:bg-primary-950",
				"overflow-hidden grow-0",
				"relative z-0",
			)}
		>
			{isSidebar && sidebarNavigation()}
			<motion.div
				layoutId="app-shell-wrapper"
				className={clsx(
					"relative",
					"grid w-full h-full",
					"transition-all",
					"rounded-base",
					isTopbar && "grid-rows-2",
					isSidebar && "pt-4",
					"border-[0.5px] border-color",
					"bg-primary-100 dark:bg-primary-950",
					"shadow-xs z-0",
					"overflow-hidden",
				)}
				style={{
					gridTemplateRows: isTopbar ? "max-content 1fr" : "1fr",
				}}
			>
				{isTopbar && topbarNavigation()}
				{children}
			</motion.div>
		</div>
	);
}
